import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 're-busy',
  imports: [],
  templateUrl: './busy.component.html',
  styleUrl: './busy.component.scss'
})
export class BusyComponent {
  @Input() busy!: boolean | null;
  @Input() message = '';
}
